import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.small.js";
import styled, { css } from 'styled-components';
import { breakpoints } from 'styles/globals';
var CollectionGridItem = styled.li.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['small', 'large'].includes(prop);
  }
}).attrs(function (p) {
  return {
    role: p.role || 'listitem'
  };
}).withConfig({
  displayName: "CollectionGridItem",
  componentId: "sc-1fgmfiq-0"
})(["display:flex;flex-shrink:0;width:100%;@media (min-width:", "){width:50%;}", " ", " &:focus{outline:none;}&.focus-visible > *{outline:3px solid ", ";outline-offset:3px;}"], breakpoints.xxs, function (p) {
  return !p.large && css(["@media (min-width:", "){width:33.333%;}"], breakpoints.s);
}, function (p) {
  return p.small && css(["@media (min-width:", "){width:25%;}"], breakpoints.m);
}, function (p) {
  return p.theme.links;
});
CollectionGridItem.defaultProps = {
  large: false,
  small: false
};
export default CollectionGridItem;